import EQUINE_1 from '../../assets/collections/profile/equine_E1.webp';
import EQUINE_2 from '../../assets/collections/profile/equine_E2.webp';
import EQUINE_3 from '../../assets/collections/profile/equine_E3.webp';
import EQUINE_4 from '../../assets/collections/profile/equine_E4.webp';
import EQUINE__1 from '../../assets/collections/profile/equine_E-1.webp';
import EQUINE__2 from '../../assets/collections/profile/equine_B-1.webp';
import EQUINE__3 from '../../assets/collections/profile/equine_C-1.webp';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
export const PROFILE_AVATARS = [
    {
        label: 'EquineNFT Profile Pictures',
        value: 'EquineNFT Profile Pictures',
        contents: [
            {
                id: 0,
                asset: Logo,
                value: 'logo'
            },
            {
                id: 1,
                asset: EQUINE_1,
                value: 'equine_1'
            },
            {
                id: 2,
                asset: EQUINE_4,
                value: 'equine_4'
            },
            {
                id: 3,
                asset: EQUINE_2,
                value: 'equine_2'
            },
            {
                id: 4,
                asset: EQUINE_3,
                value: 'equine_3'
            },
            {
                id: 5,
                asset: EQUINE__1,
                value: 'equine__1'
            },
            {
                id: 6,
                asset: EQUINE__2,
                value: 'equine__2'
            },
            {
                id: 7,
                asset: EQUINE__3,
                value: 'equine__3'
            }
        ]
    }
];
